import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import GeneralSearchComponent from '../../components/GeneralCRUDComponent/GeneralSearchComponent/GeneralSearchComponent';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  IAcademiesStore,
} from '../../mobx-store/storeInterfaces/academiesInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';

interface IProps extends WithSnackbarProps {
  academiesStore: IAcademiesStore;
  countryStore: CountryStore;
  history: any;
}

@inject('academiesStore')
@inject('countryStore')
@observer
class Academies extends Component<IProps> {
  addButton: any;

  isEgypt = false;

  tableHeader: any = [];

  tableData: any[] = [];

  tableCellTypes: TableCellTypes[] = [];

  title = 'Academies Management';

  constructor(props: IProps) {
    super(props);
  }

  async componentDidMount() {
    const {
      countryStore, academiesStore,
    } = this.props;
    await countryStore.getUserManagedCountries();
    await academiesStore.getAcademies(countryStore.managedCountries);
  }

  handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
    this.props.academiesStore.updateAcademyStatus(value, index)
      .then(() => {
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 8000, 'success');
      })
      .catch((error: any) => {
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 8000, 'error');
      });
  };

  handleTableButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(`/academies/${this.props.academiesStore.academiesList[index].academyId}/edit`);
  };

  handleAdd = (): void => {
    this.props.history.push('/academies/new');
  };

  getAddAcademyButton = () => ({
    title: 'Add',
    onAdd: this.handleAdd,
  });

  getAcademyTableHeader = () => [
    {
      title: 'Academy',
    },
    {
      title: 'Status',
    },
    {
      title: 'Edit',
    },
  ];

  getAcademyTableData = () => this.props.academiesStore.academiesList
    .map((academy) => ({
      ...academy, edit: 'Edit',
    }));

  getAcademyTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'ToggleButton',
      key: 'isActive',
      activeLabel: 'Active',
      inactiveLabel: 'Not active',
      onChange: this.handleTableToggleCellChange,
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];

  handleSearchChanged = (title: any) => {
    const {
      academiesStore, countryStore,
    } = this.props;
    title ? academiesStore.filterAcademies(title, countryStore.managedCountries)
      : academiesStore.getAcademies(countryStore.managedCountries);
  };

  render() {
    this.addButton = this.getAddAcademyButton();
    this.tableHeader = this.getAcademyTableHeader();
    this.tableCellTypes = this.getAcademyTableCellTypes();
    const {
      academiesStore, countryStore,
    } = this.props;
    const {
      loading,
      academiesList,
    } = academiesStore;
    const {
      isLoadingManagedCountries,
    } = countryStore;
    return (
      <div>
        <GeneralSearchComponent onSearchClick={this.handleSearchChanged} searchBy="title" />
        <GeneralTableComponent
          emptyMessage="There are no Academies yet. Please add a new now"
          title={this.title}
          tableHeader={this.tableHeader}
          tableData={academiesList}
          tableCellTypes={this.tableCellTypes}
          addButton={this.addButton}
          loadingStatus={[
            this.props.academiesStore.getAcademiesRequestStatus,
            this.props.countryStore.getManagedCountriesRequestStatus
          ]}
        />
      </div>
    );
  }
}

export default Academies;
